var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useRef, useImperativeHandle } from "react";
import { useIntl } from "react-intl";
import { TextField } from "@folio/stripes/components";
import { HelpTooltip } from "./HelpTooltip";
import styles from "./RecekInput.module.css";
import { useHelpTooltip } from "../../hooks/useHelpTooltip";
export var RecekTextField = forwardRef(function (_a, ref) {
    var labelId = _a.labelId, _b = _a.showLabel, showLabel = _b === void 0 ? true : _b, onChange = _a.onChange, rest = __rest(_a, ["labelId", "showLabel", "onChange"]);
    var formatMessage = useIntl().formatMessage;
    var _c = useHelpTooltip(labelId), helpId = _c.helpId, hasHelp = _c.hasHelp;
    var wrapperRef = useRef(null);
    useImperativeHandle(ref, function () { return ({
        focus: function () {
            var _a;
            var input = (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("input");
            input === null || input === void 0 ? void 0 : input.focus();
        },
    }); });
    var handleBlur = function (e) {
        var _a;
        e.target.value = (_a = e.target.value) === null || _a === void 0 ? void 0 : _a.trim();
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
    };
    return (React.createElement("div", { ref: wrapperRef, className: styles.wrapper },
        React.createElement(TextField, __assign({}, rest, { label: showLabel ? formatMessage({ id: labelId }) : undefined, autoComplete: "off", onChange: onChange, onBlur: handleBlur })),
        hasHelp && (React.createElement(HelpTooltip, { id: "".concat(labelId, "-help"), textId: helpId, hasLabel: showLabel }))));
});
